import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Page from '@Containers/Page';
import Button from '@Components/Button';
import { initHealthCheckRequester } from './healthCheckRequester';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';

const supportCenterLink = 'https://service.elsevier.com/app/home/supporthub/reaxys/';

function Error({ retry }) {
  useEffect(() => {
    if (!retry) {
      return;
    }

    // eslint-disable-next-line consistent-return
    return initHealthCheckRequester(); // returns stop function
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Page
      withHeader
      headerType="clean"
      withFooter
      pageClassName="react-page-static login-limit-page"
      className="react-page-static__wrapper">
      <h1 className="react-page-static__heading">
        <span className="ss-mug" />
        &nbsp; Internal Server Error
      </h1>
      <div className="react-page-static__content">
        <p>
          This service is currently unavailable, we apologize for any inconvenience. Please try again later.
          <br />
          Thanks for your patience.
        </p>
        <p>Please contact our support team if you have any questions</p>
        <p>
          <Button
            buttonConfig={{
              label: 'Contact Support Team',
              aTag: true,
              target: '_blank',
              href: supportCenterLink,
              type: 'link',
              size: 'sm',
              e2eName: 'contact-support-team',
            }}
            iconConfig={{
              name: 'chevron-right',
            }}
          />
        </p>
      </div>
    </Page>
  );
}

Error.propTypes = {
  retry: PropTypes.bool,
};

export default withCombinedRouteParams(Error);
